export function BannerAd() {
  return null;
}
